'use client';
import { Banner } from '@/components/MedicalProfessionalDiscounts/banner';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import AutoHeight from 'embla-carousel-auto-height';
import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '../ui/carousel';
import classes from './careGuidePage.module.css';
import PVCBoots from './pvcBoots';
import RubberBoots from './rubberBoots';
import Waders from './waders';
interface QuestionType {
  title: string;
  component: any;
}

const CareGuidePage = (): JSX.Element => {
  const { isMobile }: { isMobile: boolean } = useIsMobile();
  const questiontype: QuestionType[] = [
    { title: 'Care Guide for Rubber Boots', component: RubberBoots },
    { title: 'Care Guide for PVC Boots', component: PVCBoots },
    { title: 'Care Guide for Waders', component: Waders },
  ];
  return (
    <div>
      <Banner
        url={'/careGuide/banner'}
        title='Care Guide'
        classes={{
          titlePc: 'mb-0',
          titleMobile: 'mb-0',
          mobileBox: 'py-[20px]',
        }}
      />
      <div
        className={cn('personalContent overflow-hidde relative mx-auto pb-[40px] lg_pb-[80px]', classes.carouselBox)}
      >
        <Carousel
          opts={{ loop: true, duration: 0 }}
          plugins={[AutoHeight()]}
        >
          {isMobile ? (
            <CarouselDots
              className='mb-[20px] flex flex-wrap items-center justify-start gap-x-[40px] pl-[12px]'
              dotClassName={classes.dotClassNameMobile}
              activeDotClassName={classes.activeDotClassNameMobile}
              dotsContent={questiontype.map(item => item.title)}
            ></CarouselDots>
          ) : (
            <CarouselDots
              className='mb-[60px] flex items-center justify-start'
              dotClassName={classes.dotClassName}
              activeDotClassName={classes.activeDotClassName}
              dotsContent={questiontype.map(item => item.title)}
            ></CarouselDots>
          )}

          <CarouselContent className='-ml-0 items-start'>
            {questiontype.map((item, index) => {
              return (
                <CarouselItem
                  className='relative p-0'
                  key={index}
                >
                  <div
                    key={index}
                    className='px-[12px] lg_px-0'
                  >
                    <item.component />
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  );
};
export default CareGuidePage;
